import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';

interface IFooterColumnProps {
  title: string;
  items: {
    title: string;
    link: string;
    icon?: string;
  }[]
}

export default function FooterColumn(props: IFooterColumnProps){
  return <Container>
    <Title>{props.title}</Title>
    <p>
      {props.items.map((item, index) => 
        <a href={item.link} key={index}>
          {item.icon && <Image src={item.icon} alt="" width={55} height={54} />}{item.title}
        </a>
      )}
    </p>
  </Container>
}

const Container = styled.div`
  & p {
    display: flex;
    flex-direction: column;
    line-height: 30px;
  }

  & a {
    display: flex;
    align-items: center;
  }

  & img {
    width: 50px;
    height: auto;
    margin-left: -10px;
  }
`

const Title = styled.h3`
  text-transform: uppercase;
  font-size: var(--text-uppercase-menu-big);
  font-family: var(--font-semibold);
`